export const TaskIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Task Icon</title>
      <path
        d="M15.3575 13.7357H14.167C14.167 13.7357 13.5718 11.4369 9.40501 11.4369H5.53588C3.39893 11.4369 1.66675 9.76445 1.66675 7.70123C1.66675 5.63801 3.39893 3.9656 5.53588 3.9656H9.40501C13.5718 3.9656 14.167 1.66675 14.167 1.66675H15.3575V13.7357Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1426 9.32692C17.836 9.09014 18.3331 8.45163 18.3331 7.70106C18.3331 6.95048 17.836 6.31198 17.1426 6.0752"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83423 11.4366V3.96533"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.00776 13.7356L10.2036 17.1988C10.3965 17.7569 9.96611 18.3333 9.35658 18.3333H8.26251C7.87797 18.3333 7.5369 18.096 7.41546 17.7437L5.23804 11.4368"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
